module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-company"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, _vm._l((_vm.companies), function(company) {
    return (_vm.companies && !_vm.loading) ? _c('div', {
      key: company.uuid,
      staticClass: "company"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                        " + _vm._s(company.name) + "\n                        "), _c('br'), _vm._v(" "), (company.api_provider.name === 'Ordrestyring') ? _c('span', {
      staticStyle: {
        "background": "#339861",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                            " + _vm._s(company.api_provider.name) + "\n                        ")]) : _c('span', {
      staticStyle: {
        "background": "#852240",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                            " + _vm._s(company.api_provider.name) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.changeCompany(company)
        }
      }
    }, [_vm._v("\n                        Skift til denne virksomhed\n                        "), _c('i', {
      staticClass: "fas fa-arrow-right"
    })])]) : _c('box-loading', {
      attrs: {
        "height": "350"
      }
    })
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Skift virksomhed\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Som super admin kan du her ændre hvilken virksomhed du ønsker at se data for. Når du vælger en virksomhed, vil applikation opdatere og du ser nu de samme data, som virksomhedens egne brugere ser det.\n                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db2305ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db2305ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/changeCompany.vue
// module id = 888
// module chunks = 0